import React, { useState } from 'react';
import {
    Box,
    Container,
    Paper,
    Typography,
} from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import { usePermission } from '../../hooks/usePermission';
import EventTypeForm from '../../Components/EventTypes/EventTypeForm';
import EventTypeTable from '../../Components/EventTypes/EventTypeTable';
import { CreateEventTypesPermission } from '../../constants/permissions';

const EventTypes = () => {
    const { data: canCreateEventType } = usePermission({
        permissionName: CreateEventTypesPermission
    });

    const [open, setOpen] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        description: '',
        allow_app_sign: false,
        can_add_attendees: false,
        can_delete_attendees: false,
        can_edit_attendees: false,
        needs_organization: false,
    });

    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleClose = () => {
        setOpen(false);
        setFormData({
            name: '',
            description: '',
            allow_app_sign: false,
            can_add_attendees: false,
            can_delete_attendees: false,
            can_edit_attendees: false,
            needs_organization: false,
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    return (
        <Container maxWidth="xl">
            <Box sx={{ py: 4 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 3 }}>
                    <Typography variant="h4" component="h1">
                        Event Types
                    </Typography>
                    {canCreateEventType && (
                        <button
                            className='bg-blueColor text-white rounded-md px-4 py-2 flex items-center gap-2'
                            onClick={handleClickOpen}
                        >
                            <AddIcon />
                            Add New Event Type
                        </button>
                    )}
                </Box>

                <Paper sx={{ width: '100%', overflow: 'hidden' }}>
                    <EventTypeTable />
                </Paper>

                <EventTypeForm
                    open={open}
                    onClose={handleClose}
                    formData={formData}
                    onInputChange={handleInputChange}
                />
            </Box>
        </Container>
    );
};

export default EventTypes; 